import { useShallow } from 'zustand/react/shallow';
import storage from '../../../../../../hooks/useStorage/useStorage';
import LangEnum from '../../../../../../lang/LangEnum';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import ProductFilterToggleButton from './button/components/ProductFilterToggleButton';

const RelatedProductsFilter = () => {
  const { relatedProductsFilterState, removeCopiedGrid, toggleRelatedProductsFilterState } =
    useProductDetailsStore(
      useShallow((state) => ({
        relatedProductsFilterState: state.relatedProductsFilterState,
        removeCopiedGrid: state.removeCopiedGrid,
        toggleRelatedProductsFilterState: state.toggleRelatedProductsFilterState,
      })),
    );

  const handleToggleButton = () => {
    removeCopiedGrid();

    const newState = !relatedProductsFilterState;

    toggleRelatedProductsFilterState(newState);
    storage.setProductDetailsFilter(storage.getSessionId() as string, {
      isRelatedProductsFilterSelected: newState,
    });
  };

  return (
    <ProductFilterToggleButton
      value="relatedProducts"
      onClick={handleToggleButton}
      selected={relatedProductsFilterState}
      label={LangEnum.GLOBAL_RELATED_PRODUCTS}
    />
  );
};

export default RelatedProductsFilter;
